import { render, staticRenderFns } from "./DebugModal.vue?vue&type=template&id=20900d00&"
import script from "./DebugModal.vue?vue&type=script&lang=js&"
export * from "./DebugModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports